import React from "react";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Supplier } from "../../../Types";
import { PurchaseStatus } from "../../../Types";

const { Option } = Select;

interface Props {
  searchInput: string;
  onSearchChange: (v: string) => void;
  supplierId: string | null;
  onSupplierChange: (v: string | null) => void;
  status: string | null;
  onStatusChange: (v: string | null) => void;
  suppliers: Supplier[];
}

export const RawPurchasesFilters: React.FC<Props> = ({
  searchInput,
  onSearchChange,
  supplierId,
  onSupplierChange,
  status,
  onStatusChange,
  suppliers,
}) => (
  <div className="flex flex-wrap items-center gap-2">
    <Input
      placeholder="Search invoice, PO, or supplier"
      prefix={<SearchOutlined />}
      value={searchInput}
      onChange={(e) => onSearchChange(e.target.value)}
      allowClear
      className="w-full sm:w-56"
    />
    <Select
      placeholder="Supplier"
      value={supplierId}
      onChange={onSupplierChange}
      className="w-full sm:w-40"
      allowClear
    >
      {suppliers.map((s) => (
        <Option key={s.id} value={s.id}>
          {s.name}
        </Option>
      ))}
    </Select>
    <Select
      placeholder="Status"
      value={status}
      onChange={onStatusChange}
      className="w-full sm:w-32"
      allowClear
    >
      <Option value={PurchaseStatus.DRAFT}>{PurchaseStatus.DRAFT}</Option>
      <Option value={PurchaseStatus.COMPLETED}>
        {PurchaseStatus.COMPLETED}
      </Option>
    </Select>
  </div>
);
